module.exports = __webpack_public_path__ + "static/img/logo-4-2.372e01a2.png";